var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-graphs-section"},[_c('opt-out-report',{ref:"optout",attrs:{"error":_vm.optout.error,"graphData":_vm.optout.data,"optout":_vm.optout,"wrapperWidth":_vm.optout.width},on:{"loadGraphData":_vm.loadGraphData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }